import React, { useRef } from "react";
import type { FederatedEventHandler, Graphics } from "pixi.js";
import { bottomRightBorderColor, defaultTint, edstFontDim, topLeftBorderColor } from "~/utils/constants";
import { colorNameMap, edstFontName, eramFontDimensionMap, EramFontName, getBitmapTextStyles, useFocused } from "@poscon/shared-frontend";

type EdstButtonProps = {
  x?: number;
  y?: number;
  onmousedown?: FederatedEventHandler;
  selected?: boolean;
  disabled?: boolean;
  fontName?: EramFontName;
  text: string;
  width?: number;
};
export function EdstButton({
  onmousedown,
  disabled,
  text,
  selected = false,
  fontName = edstFontName,
  x = 0,
  y = 0,
  width = text.length * eramFontDimensionMap[fontName].width + 10,
}: EdstButtonProps) {
  const ref = useRef<Graphics>(null);
  const focused = useFocused(ref);

  const tint = disabled ? 0x707070 : defaultTint;
  const fill = selected ? 0x909090 : colorNameMap.black;

  const fontDim = eramFontDimensionMap[fontName];

  return (
    <container x={x} y={y} eventMode={disabled ? "none" : "passive"}>
      <graphics
        ref={ref}
        draw={(graphics) => {
          graphics.clear();

          graphics
            .rect(0, 0, width, fontDim.height + 4)
            .fill(fill)
            .stroke({ width: 2, color: topLeftBorderColor });
          graphics
            .moveTo(width, 0)
            .lineTo(width, fontDim.height + 4)
            .lineTo(0, fontDim.height + 4)
            .stroke({ width: 2, color: bottomRightBorderColor });
          if (focused) {
            graphics
              .rect(-1, -1, width + 2, fontDim.height + 6)
              .stroke({ width: 1, color: colorNameMap.white, alignment: 0 });
          }
        }}
        eventMode="static"
        onMouseDown={onmousedown}
      />
      <bitmapText
        text={text}
        x={Math.floor((width - text.length * fontDim.width) / 2)}
        y={3}
        eventMode="none"
        style={{
          ...getBitmapTextStyles(fontName),
          fill: tint,
        }}
      />
    </container>
  );
}

export const exitButtonHeight = edstFontDim.height + 12;
